import { SectionWithHeadingsProps } from "./section-with-headings-types";
import { SectionWithHeadingsStyled, TitleStyled } from "./style-components";

const SectionWithHeadings: React.FC<SectionWithHeadingsProps> = ({ 
    title, 
    titleColor = 'rouse', 
    titleAlign, 
    children, 
    style = {} 
}) => {
    return (
        <SectionWithHeadingsStyled style={style}>
            <TitleStyled $titleColor={titleColor} $titleAlign={titleAlign}>{title}</TitleStyled>
            {children}
        </SectionWithHeadingsStyled>
    )
}

export default SectionWithHeadings;
